import i18n from "@/i18n";

export default {
  headers: [
    {
      text: i18n.t("mementoRecord.hId"),
      value: "id",
      align: "center",
    },
    {
      text: i18n.t("Booking.hdateStartState"),
      value: "dateStart",
      align: "center",
    },
    {
      text: i18n.t("Booking.hdateEndState"),
      value: "dateEnd",
      align: "center",
    },
    {
      text: i18n.t("BookingHistory.hnameuser"),
      value: "user.firstName",
      align: "center",
    },
    { text: i18n.t("Booking.hActions"), value: "actions" },
  ],
  locale: {
    title: i18n.t("crudBookings.title"),
    search: i18n.t("crudBookings.search"),
    deleteConfirm: i18n.t("crudHistory.deleteConfirm"),
  },
};
